import { NavigationItem, NavigationChildIdentifier } from '../models/layout.model';
import { InjectionToken } from '@angular/core';

export const NON_MEMBER_NAVIGATION_CONFIG = new InjectionToken<NavigationItem[]>('NON_MEMBER_NAVIGATION_CONFIG');

export function nonMemberNavigationConfig(): NavigationItem[] {
  return [
    {
      id: 'settings',
      name: 'Settings',
      route: '/settings',
      selected: true, // default tab selection
      query: { child: NavigationChildIdentifier.Welcome },
      children: [
        {
          id: 'welcome',
          name: 'Welcome',
          icon: 'home',
          route: '/settings',
          query: { child: NavigationChildIdentifier.Welcome },
        },
        {
          id: 'personal-details',
          name: 'Personal Details',
          icon: 'account',
          route: '/settings',
          query: { child: NavigationChildIdentifier.PersonalDetails },
        },
        {
          id: 'organization-data',
          name: 'Organization Data',
          icon: 'wrench',
          route: '/settings',
          query: { child: NavigationChildIdentifier.OrganizationData },
        },
        {
          id: 'newsletter',
          name: 'Subscriptions to Newsletters',
          icon: 'newspaper',
          route: '/settings',

          query: { child: NavigationChildIdentifier.Newsletter },
        },
        {
          id: 'change-password',
          name: 'Change Password',
          icon: 'key',
          route: '/settings',

          query: { child: NavigationChildIdentifier.ChangePassword },
        },
        {
          id: 'change-email',
          name: 'Change Email',
          icon: 'arobase',
          route: '/settings',

          query: { child: NavigationChildIdentifier.ChangeEmail },
        },
        {
          id: 'deactive-account',
          name: 'Deactivate Account',
          icon: 'employee-rejections',
          route: '/settings',
          query: { child: NavigationChildIdentifier.DeactiveAccount },
        },
      ],
    },
    {
      id: 'management',
      name: 'My Requests',
      route: '/management',
      query: { child: NavigationChildIdentifier.RequestNewAffiliation },
      children: [
        {
          id: 'request-new-affiliation',
          name: 'Request New Affiliation',
          icon: 'account',
          route: '/management',
          query: { child: NavigationChildIdentifier.RequestNewAffiliation },
        },
        {
          id: 'my-non-member-requests',
          name: 'Status of Requests',
          icon: 'wrench',
          route: '/management',
          query: { child: NavigationChildIdentifier.MyNonMemberRequests },
        },
      ],
    },
  ];
}
